import { useQuery } from '@tanstack/react-query';

import { ContractMessage, ContractState } from '../../../../types/ContractMessage';
import { queries } from '../../../common/api/queryKeys/queries';
import { getInitialContractFormValues, toContractPayload } from '../../../contracts/form/contractForm.helpers';

export const useContractAwardValidation = (contract: ContractMessage) => {
    const validationContract = {
        ...toContractPayload(getInitialContractFormValues(contract)),
        state: ContractState.AWARDED,
        priceListActivationMode: contract.priceListActivationMode,
    };

    return useQuery({
        ...queries.contracts.detail(contract.id)._ctx.validation(validationContract),
        enabled: false,
        staleTime: Infinity,
    });
};
